import { useMutation as _useMutation, } from '@apollo/client';
export function useMutation(mutation, options) {
    return _useMutation(mutation, options);
}
